import React, { useState, useEffect, useRef } from "react";
import { Pagination } from "../../components/compIndex";

const PixelAssets = () => {
  const [assets, setAssets] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // Pagination
  const [selectedAsset, setSelectedAsset] = useState(null);
  const assetRefs = useRef({});

  useEffect(() => {
    // Fetch assets when the component mounts
    fetchPixelAssets();
  }, []);

  useEffect(() => {
    // Add event listener for Escape key to close the modal
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    if (selectedAsset) {
      window.addEventListener("keydown", handleEscape);
    }

    // Cleanup the event listener
    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [selectedAsset]);

  const fetchPixelAssets = async () => {
    try {
      const response = await fetch("https://api.pixelore.wiki/api/assets");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setAssets(data);
    } catch (error) {
      console.error("Failed to fetch Assets items", error);
    }
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const handleImageClick = (asset) => {
    setSelectedAsset(asset);
  };

  const closeModal = () => {
    setSelectedAsset(null);
  };

  // Filter assets based on search term
  const filteredAssets = assets
    .filter((asset) => asset.image) // Ensure image exists
    .filter((asset) => asset.id.toLowerCase().includes(search.toLowerCase()));

  const totalItems = filteredAssets.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAssets.slice(indexOfFirstItem, indexOfLastItem);
  const startPage = Math.max(1, currentPage - 2);
  const endPage = Math.min(totalPages, currentPage + 2);

  return (
    <div className="panel-style">
      <div className="md:flex">
        <h1 className="panel-heading">In-Game Assets</h1>
        {/* Search Bar */}
        <div className="ml-auto">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="mb-4 p-2 w-60 select-forms mr-10 md:w-4/5"
          />
        </div>
      </div>

      <div className="max-h-[60svh] overflow-auto">
        {/* Fixed height and scrollable */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 text-center p-2">
          {currentItems.map((asset) => (
            <div
              key={asset.id}
              ref={(el) => (assetRefs.current[asset.id] = el)}
              className="component-style relative border p-4 rounded-lg group"
            >
              
              <div className="mb-2">
                <div className="text-[var(--text-color)] truncate text-xs">{asset.id}</div>
              </div>
              <img
                src={asset.image ? asset.image?.startsWith("cdn:/") ? asset.image.replace("cdn:/", "https://d31ss916pli4td.cloudfront.net/") : asset.image : ""}
                alt={asset.name || "Asset"}
                className="w-75 h-75 ml-auto mr-auto mt-auto cursor-pointer"
                onClick={() => handleImageClick(asset)}
              />
            </div>
          ))}
        </div>

        {/* Modal for displaying the full-size image */}
        {selectedAsset && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-90 rounded-xl">
            <div className="relative overflow-auto">
              <img
                src={selectedAsset.image ? selectedAsset.image?.startsWith("cdn:/") ? selectedAsset.image.replace("cdn:/", "https://d31ss916pli4td.cloudfront.net/") : selectedAsset.image : ""}
                alt={selectedAsset.name || "Asset"}
                className="w-auto h-auto max-w-full max-h-full mx-auto"
              />
              <button
                onClick={closeModal}
                className="absolute top-2 right-2 text-white bg-red-500 hover:bg-red-600 rounded-full p-2 text-sm"
              >
                X
              </button>
              <div className="text-sm mt-10 bg-[var(--button2-bg-color)] rounded-md p-2 text-center">
                Right Click and Open in New Tab to see the image fully
              </div>
            </div>
          </div>
        )}
      </div>
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        startPage={startPage}
        endPage={endPage}
      />
    </div>
  );
};

export default PixelAssets;